import { ServiceAppointmentDeclinedMpviCode } from '@quorum/models/xs-resource';
import { ServiceAppointmentDeclinedMpviCodeQueryParameters } from '@quorum/models/xs-query';
import { Action } from '@ngrx/store';

export enum ServiceAppointmentDeclinedOperationsEntityActionTypes {
  // eslint-disable-next-line max-len
  GetServiceAppointmentDeclinedOperationsFromServer = '[Fixed Operations] Get Service Appointment Declined Operations From Server',
  // eslint-disable-next-line max-len
  GetServiceAppointmentDeclinedOperationsFromServerError = '[Fixed Operations] Get Service Appointment Declined Operations From Server Error',
  // eslint-disable-next-line max-len
  GetServiceAppointmentDeclinedOperationsFromServerSuccess = '[Fixed Operations] Get Service Appointment Declined Operations From Server Success',
  // eslint-disable-next-line max-len
  CreateServiceAppointmentDeclinedOperationsOnServer = '[Fixed Operations] Create Service Appointment Declined Operations On Server',
  // eslint-disable-next-line max-len
  CreateServiceAppointmentDeclinedOperationsOnServerError = '[Fixed Operations] Create Service Appointment Declined Operations On Server Error',
  // eslint-disable-next-line max-len
  CreateServiceAppointmentDeclinedOperationsOnServerSuccess = '[Fixed Operations] Create Service Appointment Declined Operations On Server Success',
  DeleteSelectedAppointmentDeclinedMpviFromServer = '[Fixed Operations] Delete Service Appointment Declined Mpvi From Server',
  DeleteSelectedAppointmentDeclinedMpviFromServerError = '[Fixed Operations] Delete Service Appointment Declined Mpvi From Server Error',
  DeleteSelectedAppointmentDeclinedMpviFromServerSuccess = '[Fixed Operations] Delete Service Appointment Declined Mpvi From Server Success',
  UpdateSelectedAppointmentDeclinedMpviOnServer = '[Fixed Operations] Update Service Appointment Declined Mpvi On Server',
  UpdateSelectedAppointmentDeclinedMpviOnServerError = '[Fixed Operations] Update Service Appointment Declined Mpvi On Server Error',
  UpdateSelectedAppointmentDeclinedMpviOnServerSuccess = '[Fixed Operations] Update Service Appointment Declined Mpvi On Server Success',
}

export class GetServiceAppointmentDeclinedOperationsFromServer implements Action {
  readonly type =
    ServiceAppointmentDeclinedOperationsEntityActionTypes.GetServiceAppointmentDeclinedOperationsFromServer;
  constructor(public payload: ServiceAppointmentDeclinedMpviCodeQueryParameters) {}
}
export class GetServiceAppointmentDeclinedOperationsFromServerError implements Action {
  readonly type =
    ServiceAppointmentDeclinedOperationsEntityActionTypes.GetServiceAppointmentDeclinedOperationsFromServerError;
  constructor(public payload: any) {}
}
export class GetServiceAppointmentDeclinedOperationsFromServerSuccess implements Action {
  readonly type =
    ServiceAppointmentDeclinedOperationsEntityActionTypes.GetServiceAppointmentDeclinedOperationsFromServerSuccess;
  constructor(public payload: ServiceAppointmentDeclinedMpviCode[]) {}
}

export class CreateServiceAppointmentDeclinedOperationsOnServer implements Action {
  readonly type =
    ServiceAppointmentDeclinedOperationsEntityActionTypes.CreateServiceAppointmentDeclinedOperationsOnServer;
  constructor(public payload: ServiceAppointmentDeclinedMpviCode) {}
}
export class CreateServiceAppointmentDeclinedOperationsOnServerError implements Action {
  readonly type =
    ServiceAppointmentDeclinedOperationsEntityActionTypes.CreateServiceAppointmentDeclinedOperationsOnServerError;
  constructor(public payload: any) {}
}
export class CreateServiceAppointmentDeclinedOperationsOnServerSuccess implements Action {
  readonly type =
    ServiceAppointmentDeclinedOperationsEntityActionTypes.CreateServiceAppointmentDeclinedOperationsOnServerSuccess;
  constructor(public payload: ServiceAppointmentDeclinedMpviCode) {}
}

export class DeleteSelectedAppointmentDeclinedMpviFromServer implements Action {
  readonly type = ServiceAppointmentDeclinedOperationsEntityActionTypes.DeleteSelectedAppointmentDeclinedMpviFromServer;
  constructor(public payload: ServiceAppointmentDeclinedMpviCode) {}
}
export class DeleteSelectedAppointmentDeclinedMpviFromServerError implements Action {
  readonly type =
    ServiceAppointmentDeclinedOperationsEntityActionTypes.DeleteSelectedAppointmentDeclinedMpviFromServerError;
  constructor(public payload: any) {}
}
export class DeleteSelectedAppointmentDeclinedMpviFromServerSuccess implements Action {
  readonly type =
    ServiceAppointmentDeclinedOperationsEntityActionTypes.DeleteSelectedAppointmentDeclinedMpviFromServerSuccess;
  constructor(public payload: ServiceAppointmentDeclinedMpviCode) {}
}

export class UpdateSelectedAppointmentDeclinedMpviOnServer implements Action {
  readonly type = ServiceAppointmentDeclinedOperationsEntityActionTypes.UpdateSelectedAppointmentDeclinedMpviOnServer;
  constructor(public payload: ServiceAppointmentDeclinedMpviCode) {}
}
export class UpdateSelectedAppointmentDeclinedMpviOnServerError implements Action {
  readonly type =
    ServiceAppointmentDeclinedOperationsEntityActionTypes.UpdateSelectedAppointmentDeclinedMpviOnServerError;
  constructor(public payload: any) {}
}
export class UpdateSelectedAppointmentDeclinedMpviOnServerSuccess implements Action {
  readonly type =
    ServiceAppointmentDeclinedOperationsEntityActionTypes.UpdateSelectedAppointmentDeclinedMpviOnServerSuccess;
  constructor(public payload: ServiceAppointmentDeclinedMpviCode) {}
}

export type ServiceAppointmentDeclinedOperationsEntityAction =
  | GetServiceAppointmentDeclinedOperationsFromServer
  | GetServiceAppointmentDeclinedOperationsFromServerError
  | GetServiceAppointmentDeclinedOperationsFromServerSuccess
  | CreateServiceAppointmentDeclinedOperationsOnServer
  | CreateServiceAppointmentDeclinedOperationsOnServerError
  | CreateServiceAppointmentDeclinedOperationsOnServerSuccess
  | DeleteSelectedAppointmentDeclinedMpviFromServer
  | DeleteSelectedAppointmentDeclinedMpviFromServerError
  | DeleteSelectedAppointmentDeclinedMpviFromServerSuccess
  | UpdateSelectedAppointmentDeclinedMpviOnServer
  | UpdateSelectedAppointmentDeclinedMpviOnServerError
  | UpdateSelectedAppointmentDeclinedMpviOnServerSuccess;

export const fromServiceAppointmentDeclinedOperationsEntityActions = {
  GetServiceAppointmentDeclinedOperationsFromServer,
  GetServiceAppointmentDeclinedOperationsFromServerError,
  GetServiceAppointmentDeclinedOperationsFromServerSuccess,
  CreateServiceAppointmentDeclinedOperationsOnServer,
  CreateServiceAppointmentDeclinedOperationsOnServerError,
  CreateServiceAppointmentDeclinedOperationsOnServerSuccess,
  DeleteSelectedAppointmentDeclinedMpviFromServer,
  DeleteSelectedAppointmentDeclinedMpviFromServerError,
  DeleteSelectedAppointmentDeclinedMpviFromServerSuccess,
  UpdateSelectedAppointmentDeclinedMpviOnServer,
  UpdateSelectedAppointmentDeclinedMpviOnServerError,
  UpdateSelectedAppointmentDeclinedMpviOnServerSuccess,
};
